import { render } from "./SignupLayout.vue?vue&type=template&id=206e18b3"
import script from "./SignupLayout.vue?vue&type=script&lang=js"
export * from "./SignupLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__